var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.resultData.length > 0)?_c('div',{staticClass:"--keywords"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Keywords')))]),_vm._v(" "),_c('ul',_vm._l((_vm.resultData),function(keyword,index){return _c('li',{key:index},[_c('a',{attrs:{"href":keyword['url']},domProps:{"innerHTML":_vm._s(keyword['label'])}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }